import React from 'react';

export default (props) => {
  const { location } = props;
  window.location = `/api/ui/zendesk/jwt_token${location.search}`;
  return <div />;
};
